import * as debug from "./debug";

export function toNumber(val: unknown): number {
  if (val === null || val === undefined) {
    return 0;
  }
  return Number(val);
}

export function moneyToNumber(val: unknown): number {
  if (val === null || val === undefined) {
    return 0;
  }
  let valToParse = val;
  if (typeof val === "string") {
    valToParse = val.replace(/\./g, "").replace(/,/g, ".");
  }
  return Number(valToParse);
}

export function toString(val: unknown): string | undefined {
  if (val === null || val === undefined) {
    return undefined;
  }
  if (typeof val === "string") {
    return val;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (val as any).toString();
}

export function toFixed(val: number | null | undefined, decimals: number): string {
  if (val === null || val === undefined) {
    return "0";
  }
  return toNumber(val).toFixed(decimals);
}

export function toNumberSafe(val: unknown): number {
  const converted = toNumber(val);
  if (isNaN(converted)) {
    return 0;
  }
  return converted;
}

export function toNumberID(val: unknown): number | undefined {
  if (!val) {
    return undefined;
  }
  const num = toNumberSafe(val);
  if (!num) {
    return undefined;
  }
  return num;
}

export function toBool(val: unknown): boolean {
  const parsedBool = toBoolOrNull(val);
  if (parsedBool === null) {
    debug.logError("Invalid boolean string: '", val, "', returning default");
    return !!val;
  }
  return parsedBool;
}

export function toBoolOrNull(val: unknown): boolean | null {
  if (val === null || val === undefined || val === "") {
    return false;
  }
  if (typeof val === "string") {
    const lowC = val.toLowerCase();
    if (lowC === "true" || lowC === "s" || lowC === "y" || lowC === "1" || lowC === "yes" || lowC === "si") {
      return true;
    } else if (lowC === "false" || lowC === "n" || lowC === "0" || lowC === "no") {
      return false;
    }
    return null;
  }
  return !!val;
}
